// Library methods
import { useTranslation } from "react-i18next";

// Components
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import DefaultModal from "../../../../components/UI/DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../../styles/muiStylesHelper";

const DuplicateExamModal = ({ isLoading, open, onClose, onConfirm }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("exams_duplicate_confirmation")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button
            variant="text"
            disabled={isLoading}
            sx={ModalCustomCancel}
            onClick={onClose}
          >
            {t("button_cancel")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {isLoading ? t("word_loading") : t("button_duplicate")}
          </Button>
        </Grid>
      }
    >
      <Grid p="20px">{t("exams_duplicate_description")}</Grid>
    </DefaultModal>
  );
};

export default DuplicateExamModal;
